import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  openIcon: {
    fontSize: theme.typography.pxToRem(32),
  },
  closeButton: {
    backgroundColor: theme.palette.primary.main,
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.common.white,
    borderRadius: theme.spacing(3),
    padding: `${theme.spacing()}px ${theme.spacing(3)}px`,
  },
}));
